import { SerializedWidget } from '../Widget'

let warn = cons => name => param => {
  if(!param){
    cons.warn("Missing required parameter", name)
  }
  return param;
};


export const emptyDashboard = {
  layouts: {},
  widgets: []
};

/**
 * Interact with orion storage.
 * Requires http request functions that handle authentication on their own.
 * Only handles mapping data to/from the orion storage.
 */
export default class OrionStorage {
  constructor(id, appId, tenantId, request, { defaultLayout } = {}) {
    let required = warn(console);
    this.id = id;
    this.defaultLayout = defaultLayout || emptyDashboard;
    this.appId = required("appId")(appId);
    this.tenantId = required("tenantId")(tenantId);
    this.reqeust = required("reqeust")(request);
  }

  invalid(){
    return !this.tenantId || !this.appId || !this.reqeust;
  }

  stubbedResponse(){
    console.log("Blocking request on invalid orion storage");
    return new Promise(resolve => {
      resolve(this.defaultLayout)
    })
  }
  /**
   * Save a dashboard data structure.
   * {
   *   layouts: {},
   *   widgets: []
   * }
   * Other fields are ignored.
   * @param dashboard
   */
  save(dashboard) {
    let {layouts, widgets} = dashboard;
    if(this.invalid()){
      return this.stubbedResponse()
    }
    let serializedWidgets = widgets.map(w => {
      let name = (w.className || w);
      return new SerializedWidget(w.id, name);
    });
    return this.reqeust.post("user-info/metadata", [
      {
        key: this.id,
        value: {
          layouts: layouts,
          widgets: serializedWidgets
        }
      }
    ], {
      params: {
        uaid: this.appId,
        tid: this.tenantId
      }})
  }
  delete() { // this is a debugging function that allows you to delete your dashboard's saved layout
    return this.reqeust.delete("user-info/metadata", {
      params: {
        keys: this.id,
        uaid: this.appId,
        tid: this.tenantId
      }})
  }

  load() {
    if(this.invalid()){
      return this.stubbedResponse()
    }
    return this.reqeust.get("user-info/metadata", {
      params: {
        keys: this.id,
        uaid: this.appId,
        tid: this.tenantId
      }
    }).then(resp => {
      return (resp.data && resp.data[0] && resp.data[0].value) || this.defaultLayout;
    })
  }

  equals(other) {
    return other && other.id && other.appId && other.tenantId
      && other.id === this.id
      && other.appId === this.appId
      && other.tenantId === this.tenantId;
  }
}
